import React, { useState, useEffect, useRef } from "react";
import { useHistory, useRouteMatch } from "react-router-dom";
import { MdOutlinePeopleAlt, MdLockOutline } from "react-icons/md";
import { GoGlobe } from "react-icons/go";
import { useDispatch } from "react-redux";
import { POST_DELETED } from "../../redux/actions/journal";
// import NoImage from "../../common/noimage/no-image.jpg"
import ButtonHashtag from "../../components/Button/ButtonHashtag";
import ModalShare from "./ModalShare";
import ShareTo from "../Community/ShareTo";
import RichContent from "../../components/Editor/RichContent";
import {
  htmlToText,
  trimString,
  convertDate,
  removeIframe,
  tokenAuthorize,
  addAttribute,
} from "../../components/Helpers/Common";
import axios from "axios";
import Swal from "sweetalert2";
import { serverUrl } from "../../components/Helpers/Config";
import { staticFiles } from "../../components/Helpers/Static";
import { FaRegCommentDots } from "react-icons/fa";
import ThumbUpAltIcon from "@mui/icons-material/ThumbUpAlt";
import {
  ButtonCommonDelete,
  ButtonCommonTopGrey,
  ButtonCommonTopNew,
  Card,
  CardNew,
  MenuItemCard,
  MenuItemDiv,
} from "../Theme";
import Menu from "@mui/material/Menu";
import {
  fillList,
  hideShareto,
  showShareto,
} from "../../redux/actions/sharePost";
import JournalHashtag from "../../components/Button/JournalHashtag";
import FeedbackHistoryButton from "../../components/Button/FeedbackHistoryButton";
import { getPosts } from "../../redux/actions/journal";
import { getShowcaseDetails } from "../../redux/actions/showcase";
import { ActiveIconColor } from "../Theme";
import MenuItem from "@mui/material/MenuItem";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import { FaTrashAlt } from "react-icons/fa";
import BorderColorOutlinedIcon from "@mui/icons-material/BorderColorOutlined";
import ShareIcon from "@mui/icons-material/Share";
import Tooltip from "@mui/material/Tooltip";
const NO_IMAGE = staticFiles.noImage;

const JournalCards = ({
  item,
  selection,
  index,
  set,
  getShared,
  historyEnabled,
  ...props
}) => {
  const { path } = useRouteMatch();
  const history = useHistory();
  const dispatch = useDispatch();
  const popupRef = useRef();
  const [showModalShare, setShowModalShare] = useState(false);

  const [isMobile1, setisMobile1] = useState(false);
  const [isMobile2, setisMobile2] = useState(false);
  const [isMobile3, setisMobile3] = useState(false);
  const [isMobile4, setisMobile4] = useState(false);

  const [anchorElJournal, setAnchorEl] = useState(null);
  const open = Boolean(anchorElJournal);
  const handleDownloadClick = (e) => {
    e.stopPropagation();
    setAnchorEl(e.currentTarget);
  };

  const handleDownloadClose = (e, reflectionId, file) => {
    e.stopPropagation();
    setAnchorEl(null);
    if (reflectionId) {
      handleDownload(e, reflectionId, file);
    }
  };

  const Tags = ({ text, ...props }) => {
    let icon =
      props.type === "showcase" ? (
        <GoGlobe className="mr-2" />
      ) : props.type === "community" ? (
        <MdOutlinePeopleAlt className="mr-2" />
      ) : props.type === "private" ? (
        <MdLockOutline className="mr-2" />
      ) : (
        ""
      );

    let texts =
      props.type === "showcase" || props.type === "community"
        ? `${text}`
        : `shared in ${text}`;

    let style =
      text === "private"
        ? "bg-gray-200 text-gray-500"
        : "bg-blue-200 text-blue-500";
    style += " w-max p-2 px-4 rounded-lg flex items-center font-semibold";
    return (
      <Tooltip title={texts} placement="top" arrow>
        <div className={style}>
          {icon} {texts}
        </div>
      </Tooltip>
    );
  };

  const handleSelect = (e) => {
    e.stopPropagation();
    set(e);
  };

  const handleEdit = (e) => {
    e.stopPropagation();
    history.push(`/journal/edit/${item.reflection_id}`, {
      post: item,
      journal: true,
    });
  };

  // const handleShare = (e) => {
  //     e.stopPropagation();
  //     setShowModalShare(true)
  // }
  const handleShareTo = (e, item) => {
    // setDropdown(false)
    e.stopPropagation();
    dispatch(showShareto());
    dispatch(fillList([item]));
  };

  const handleCloseModal = (e) => {
    e.stopPropagation();
    setShowModalShare(false);
  };

  const handleDelete = (e) => {
    e.stopPropagation();

    Swal.fire({
      heightAuto: false,
      title: "Confirmation",
      text: "Are you sure to delete this post?",
      icon: "warning",
      showCancelButton: false,
      showDenyButton: true,
      confirmButtonText: "Confirm",
      denyButtonText: "Cancel",
      confirmButtonColor: "#3085d6",
      denyButtonColor: "#c1c1c1",
    }).then((result) => {
      if (result.isConfirmed) {
        axios
          .delete(`${serverUrl.Post}/${item.reflection_id}`)
          .then(() => {
            dispatch({
              type: POST_DELETED,
              payload: { postId: item.reflection_id },
            });
            dispatch(getShowcaseDetails());
            dispatch(getPosts());
            getShared();
            Swal.fire({
              heightAuto: false,
              title: "Success",
              text: "Post has been deleted",
              icon: "success",
            });
          })
          .catch((err) => {
            tokenAuthorize(err?.response?.status);
            // Swal.close();
          });
      }
    });
  };

  useEffect(() => {
    const interval = setInterval(() => {
      resize();
    }, 100);
    return () => {
      clearInterval(interval);
    };
  }, []);
  // useEffect(() => {
  //     const handleClick = (e) => {
  //         if (!popupRef.current.contains(e.target)) {
  //             setDropdown(false);
  //         }
  //     };
  //     document.addEventListener("mousedown", handleClick, false);
  //     return function cleanup() {
  //         document.removeEventListener("mousedown", handleClick, false);
  //     };
  // });
  const resize = () => {
    if (window.innerWidth < 1450 && window.innerWidth > 1150) {
      setisMobile1(true);
    } else {
      setisMobile1(false);
    }

    if (window.innerWidth > 1020 && window.innerWidth < 1150) {
      setisMobile2(true);
    } else {
      setisMobile2(false);
    }

    if (window.innerWidth > 768 && window.innerWidth < 1020) {
      setisMobile3(true);
    } else {
      setisMobile3(false);
    }

    if (window.innerWidth < 768) {
      setisMobile4(true);
    } else {
      setisMobile4(false);
    }
  };
  const handleDownload = async (e, id, file) => {
    e.stopPropagation();
    try {
      let url =
        file === "word"
          ? serverUrl.ReflectionExportWord
          : serverUrl.ReflectionExport;
      const response = await axios.get(`${url + "/" + id}`, {
        headers: { "Content-Type": "multipart/form-data" },
        responseType: "blob",
      });
      if (response.status === 200) {
        // Extract Content-Disposition header
        const contentDisposition =
          (response.headers && response.headers["content-disposition"]) ||
          response.headers["Content-Disposition"];
        // Default filename
        let filename = file === "word" ? "reflection.docx" : "reflection.pdf";
        // Extract filename from Content-Disposition
        if (contentDisposition) {
          const match = contentDisposition.match(
            /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/
          );
          if (match && match[1]) {
            filename = match[1].replace(/['"]/g, ""); // Remove quotes if present
          }
        }
        // Create Blob and trigger download
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", filename);
        document.body.appendChild(link);
        link.click();
      } else {
        Swal.fire({
          title: "Info",
          text: "No data found",
          icon: "info",
        });
      }
    } catch (err) {
      console.error("Error:", err);
      Swal.fire({
        title: "Info",
        text: "No data found",
        icon: "info",
      });
    }
  };

  const navigateHistoryPage = (e, reflectionID) => {
    e.stopPropagation();
    history.push(`/journal/edit/${reflectionID}/pastreviewhistory`);
  };

  const formatModernDate = (isoDate) => {
    const date = new Date(isoDate);
    return date.toLocaleDateString("en-GB", {
      year: "numeric",
      month: "short", // Jan, Feb, Mar, etc.
      day: "numeric", // 1, 2, 3...
    });
  };

  return (
    <CardNew
      className="relative flex shadow-sm  border20px w-full bg-white rounded-lg py-5 md:py-8 mt-5 md:mt-6 cursor-pointer hover:opacity-90"
      onClick={props.onClick}
    >
      {props.selectEnabled && (
        <input
          type="checkbox"
          className="absolute top-4 cursor-pointer right-6 w-4 h-4 checkBoxCustom"
          name={item.reflection_id}
          checked={selection}
          onChange={handleSelect}
          onClick={(e) => {
            e.stopPropagation();
          }}
        />
      )}
      <div className="flex flex-col w-full md:grid grid-cols-9 px-6">
        {isMobile4 ? (
          <div className="w-full">
            <div className={`${"grid grid-cols-8"}`}>
              <div className="col-span-8 pr-3 font-semibold pb-4 break-words h-7 multiline-ellipsis1 blackColor">
                {item.reflection_title}
              </div>
              {/* <div className="col-span-8 font-medium text-sm lightColor">
                {formatModernDate(item.reflection_created_on)}
              </div> */}
              <div className="flex col-span-8 items-center justify-between ">
                <span className="font-medium text-sm lightColor">
                  {formatModernDate(item.reflection_created_on)}
                </span>
                <span className="font-medium text-sm lightColor gap-2 flex">
                  <span className="flex items-center">
                    <ThumbUpAltIcon fontSize="small" /> {item.likecount}
                  </span>
                  <span className="flex items-center gap-0.5">
                    <FaRegCommentDots />
                    {item.commentcount}
                  </span>
                  {/* <span>Likes - {item.likecount}</span>
              <span>Comments - {item.commentcount}</span> */}
                </span>
              </div>
              <div className="col-span-8 mt-2">
                <img
                  src={item.reflection_image ? item.reflection_image : NO_IMAGE}
                  className="w-full h-auto object-cover border20px"
                  alt=""
                  onError={(e) => {
                    e.target.src = NO_IMAGE;
                  }}
                />
              </div>
              <div className="col-span-8 mt-2">
                <div className="text-viewer text-sm max-h-36 md:max-h-40 overflow-hidden container-multi break-words">
                  <div
                    className="multiline-ellipsis4"
                    dangerouslySetInnerHTML={{
                      __html: removeIframe(item.reflection_content),
                    }}
                  />
                </div>
              </div>
            </div>
            {((item.shared && item.shared.length > 0) ||
              (item.hashtag && item.hashtag.length > 0) ||
              (item.values && item.values.length > 0) ||
              (item.events && item.events.length > 0) ||
              (item.courses && item.courses.length > 0)) && (
                <div className=" my-5 multiline-ellipsis1">
                  <div className="flex flex-wrap gap-2 overflow-x-hidden">
                    {item.shared &&
                      item.shared.map((el, idx) => (
                        <Tags key={idx} text={el} type="shared" />
                      ))}

                    {item.hashtag &&
                      item.hashtag.map((el, idx) => (
                        <JournalHashtag
                          key={idx}
                          text={trimString(el, 15)}
                          color="blue"
                          fullTitle={el}
                        />
                      ))}

                    {item.values &&
                      item.values.map((el, idx) => (
                        <ButtonHashtag
                          key={idx}
                          text={trimString(el.value, 15)}
                          color="orange"
                          fullTitle={el.value}
                        />
                      ))}
                    {item.events &&
                      item.events.map((el, idx) => (
                        <ButtonHashtag
                          key={idx}
                          text={trimString(el.value, 15)}
                          color="green"
                          fullTitle={el.value}
                        />
                      ))}
                    {item.courses &&
                      item.courses.map((el, idx) => (
                        <ButtonHashtag
                          key={idx}
                          text={trimString(el.value)}
                          color="red"
                          fullTitle={el.value}
                        />
                      ))}
                  </div>
                </div>
              )}
            <div
              className={`gap-2 sm:h-7 mt-3 flex flex-wrap ${item.feedbackcount !== "0" && historyEnabled
                ? "justify-start"
                : "justify-start"
                }`}
            >
              {item.feedbackcount !== "0" && historyEnabled ? (
                <>
                  <FeedbackHistoryButton
                    text="Feedback History"
                    color="blue"
                    onClick={(e) => navigateHistoryPage(e, item.reflection_id)}
                  />{" "}
                </>
              ) : (
                <></>
              )}
              <ButtonCommonTopNew
                className={`flex flex-row bg-blue-light hover:opacity-80 rounded-md px-2 py-1 items-center justify-center w-flex`}
                id="journal-download-button"
                aria-controls={
                  open ? "journal-download-menu" + index : undefined
                }
                aria-haspopup="true"
                aria-expanded={open ? "true" : undefined}
                onClick={(e) => handleDownloadClick(e)}
              >
                <FileDownloadOutlinedIcon
                  sx={{ fontSize: "20px !important" }}
                  className="blueColor"
                />
                <p className={`text-blue-dark font-regular text-xs`}>
                  Download
                </p>
              </ButtonCommonTopNew>
              <Menu
                id={"journal-download-menu" + index}
                anchorEl={anchorElJournal}
                open={open}
                onClose={(e) => handleDownloadClose(e)}
                MenuListProps={{
                  "aria-labelledby": "journal-download-button",
                }}
                disableScrollLock={true}
              >
                <MenuItemDiv
                  className="w-20 text-sm pt-1 flex items-center hover:opacity-70 cursor-pointer ml-3"
                  onClick={(e) =>
                    handleDownloadClose(e, item.reflection_id, "pdf")
                  }
                >
                  PDF
                </MenuItemDiv>
                <MenuItemDiv
                  className="w-20 text-sm pt-1 flex items-center hover:opacity-70 cursor-pointer ml-3"
                  onClick={(e) =>
                    handleDownloadClose(e, item.reflection_id, "word")
                  }
                >
                  Word
                </MenuItemDiv>
              </Menu>
            </div>
            <div className="flex col-span-8 mt-2 flex-wrap  w-full  justify-start  items-center gap-x-2 gap-y-0">
              <ButtonCommonTopNew
                className={`${isMobile2 || isMobile3 ? "w-20 md:w-20" : "w-24 md:w-24"
                  } ${" rounded-lg py-2  flex mb-2 md:mb-0 justify-center items-center font-regular  text-xs lg:text-sm"}`}
                onClick={handleEdit}
              >
                <BorderColorOutlinedIcon
                  style={{ fontSize: "14px" }}
                  className="mr-1 blueColor"
                />
                Edit
              </ButtonCommonTopNew>
              <ButtonCommonTopNew
                className={`${isMobile2 || isMobile3 ? "w-20 md:w-20" : "w-24 md:w-24"
                  } ${"rounded-lg py-2 mb-2 md:mb-0 flex  md:mr-0 justify-center items-center font-regular  text-xs lg:text-sm"}`}
                onClick={(e) => handleShareTo(e, item)}
              >
                <ShareIcon
                  style={{ fontSize: "15px" }}
                  className="mr-1 blueColor"
                />
                Share
              </ButtonCommonTopNew>
              <ButtonCommonDelete
                className={`${isMobile2 || isMobile3 ? "w-20 md:w-20" : "w-24 md:w-24"
                  } ${"rounded-lg py-2 mb-2 md:mb-0 flex  md:mr-0 justify-center items-center font-regular  text-xs lg:text-sm"}`}
                onClick={handleDelete}
              >
                <FaTrashAlt
                  style={{ fontSize: "14px" }}
                  className="mr-1 deleteColor"
                />
                Delete
              </ButtonCommonDelete>
            </div>
          </div>
        ) : (
          <div className=" w-full md:grid grid-cols-10 col-span-9 col-span-3 xxl:col-span-2">
            <div className="md:col-span-3 lg:col-span-3 xl:col-span-3">
              <div
                className={`${isMobile3 || isMobile1 || isMobile2 ? "pl-0" : ""
                  } ${" flex items-start gap-2"}`}
              >
                <div className="w-full overflow-hidden">
                  <img
                    src={
                      item.reflection_image ? item.reflection_image : NO_IMAGE
                    }
                    className="w-full h-auto object-cover border20px"
                    alt=""
                    onError={(e) => {
                      e.target.src = NO_IMAGE;
                    }}
                  />
                </div>
              </div>
            </div>
            <div className="md:col-span-7 lg:col-span-7 xl:col-span-7 xxl:col-span-8 col-span-7 md:pl-5 pl-2">
              <div
                className={` ${(isMobile1 || isMobile2) && "px"
                  } ${" flex flex-col h-full"}`}
              >
                <div className="mb-3  font-semibold  break-words  multiline-ellipsis2 mb-0  blackColor pb-0">
                  <div className="w-full">{item.reflection_title}</div>
                  {/* <div className="font-medium  text-sm lightColor w-full ">
                    {formatModernDate(item.reflection_created_on)}
                  </div> */}
                  <div className="flex items-center justify-between ">
                    <span className="font-medium text-sm lightColor">
                      {formatModernDate(item.reflection_created_on)}
                    </span>
                    <span className="font-medium text-sm lightColor gap-2 flex">
                      <span className="flex items-center">
                        <ThumbUpAltIcon fontSize="small" /> {item.likecount}
                      </span>
                      <span className="flex items-center gap-0.5">
                        <FaRegCommentDots />
                        {item.commentcount}
                      </span>
                      {/* <span>Likes - {item.likecount}</span>
              <span>Comments - {item.commentcount}</span> */}
                    </span>
                  </div>
                </div>
                {((item.shared && item.shared.length > 0) ||
                  (item.hashtag && item.hashtag.length > 0) ||
                  (item.values && item.values.length > 0) ||
                  (item.events && item.events.length > 0) ||
                  (item.courses && item.courses.length > 0)) && (
                    <div className="mb-3 p-0 m-0 multiline-ellipsis1">
                      <div className="flex flex-wrap gap-2 overflow-x-hidden">
                        {item.shared &&
                          item.shared.map((el, idx) => (
                            <Tags key={idx} text={el} type="shared" />
                          ))}

                        {item.hashtag &&
                          item.hashtag.map((el, idx) => (
                            <JournalHashtag
                              key={idx}
                              text={trimString(el, 15)}
                              color="blue"
                              fullTitle={el}
                            />
                          ))}

                        {item.values &&
                          item.values.map((el, idx) => (
                            <ButtonHashtag
                              key={idx}
                              text={trimString(el.value, 15)}
                              color="orange"
                              fullTitle={el.value}
                            />
                          ))}
                        {item.events &&
                          item.events.map((el, idx) => (
                            <ButtonHashtag
                              key={idx}
                              text={trimString(el.value, 15)}
                              color="green"
                              fullTitle={el.value}
                            />
                          ))}
                        {item.courses &&
                          item.courses.map((el, idx) => (
                            <ButtonHashtag
                              key={idx}
                              text={trimString(el.value)}
                              color="red"
                              fullTitle={el.value}
                            />
                          ))}
                      </div>
                    </div>
                  )}
                <div className="mb-3 flex gap-2 ">
                  <RichContent
                    className=" w-full md:w-full text-sm max-h-36 md:max-h-44 overflow-hidden container-multi break-words"
                    content={removeIframe(item.reflection_content)}
                  />
                </div>

                <div className="flex mt-auto flex-wrap items-center  w-full  justify-between  items-center gap-3">
                  <div className="flex items-center gap-2">
                    {item.feedbackcount !== "0" && historyEnabled ? (
                      <>
                        <FeedbackHistoryButton
                          text="Feedback History"
                          color="blue"
                          onClick={(e) =>
                            navigateHistoryPage(e, item.reflection_id)
                          }
                        />{" "}
                      </>
                    ) : (
                      <></>
                    )}
                    <ButtonCommonTopNew
                      className={`flex flex-row  rounded-md px-3 py-2 items-center justify-center w-flex text-xs lg:text-sm`}
                      id="journal-download-button"
                      aria-controls={
                        open ? "journal-download-menu" + index : undefined
                      }
                      aria-haspopup="true"
                      aria-expanded={open ? "true" : undefined}
                      onClick={(e) => handleDownloadClick(e)}
                    >
                      <FileDownloadOutlinedIcon
                        sx={{ fontSize: "18px !important" }}
                        className="blueColor"
                      />
                      <p className={` font-regular text-xs lg:text-sm`}>
                        Download
                      </p>
                    </ButtonCommonTopNew>
                    <Menu
                      id={"journal-download-menu" + index}
                      anchorEl={anchorElJournal}
                      open={open}
                      onClose={(e) => handleDownloadClose(e)}
                      MenuListProps={{
                        "aria-labelledby": "journal-download-button",
                      }}
                      disableScrollLock={true}
                    >
                      <MenuItemDiv
                        className="w-20 text-sm pt-1 flex items-center hover:opacity-70 cursor-pointer ml-3"
                        onClick={(e) =>
                          handleDownloadClose(e, item.reflection_id, "pdf")
                        }
                      >
                        PDF
                      </MenuItemDiv>
                      <MenuItemDiv
                        className="w-20 text-sm pt-1 flex items-center hover:opacity-70 cursor-pointer ml-3"
                        onClick={(e) =>
                          handleDownloadClose(e, item.reflection_id, "word")
                        }
                      >
                        Word
                      </MenuItemDiv>
                    </Menu>
                  </div>
                  <div className="flex items-center gap-2">
                    <ButtonCommonTopNew
                      className={`${isMobile2 || isMobile3 ? "w-20 md:w-20" : "w-24 md:w-24"
                        } ${" rounded-lg py-2  flex mb-2 md:mb-0 justify-center items-center font-regular  text-xs lg:text-sm"}`}
                      onClick={handleEdit}
                    >
                      <BorderColorOutlinedIcon
                        style={{ fontSize: "14px" }}
                        className="mr-1 blueColor"
                      />
                      Edit
                    </ButtonCommonTopNew>
                    <ButtonCommonTopNew
                      className={`${isMobile2 || isMobile3 ? "w-20 md:w-20" : "w-24 md:w-24"
                        } ${"rounded-lg py-2 mb-2 md:mb-0 flex  md:mr-0 justify-center items-center font-regular  text-xs lg:text-sm"}`}
                      onClick={(e) => handleShareTo(e, item)}
                    >
                      <ShareIcon
                        style={{ fontSize: "15px" }}
                        className="mr-1 blueColor"
                      />
                      Share
                    </ButtonCommonTopNew>
                    <ButtonCommonDelete
                      className={`${isMobile2 || isMobile3 ? "w-20 md:w-20" : "w-24 md:w-24"
                        } ${"rounded-lg py-2 mb-2 md:mb-0 flex  md:mr-0 justify-center items-center font-regular  text-xs lg:text-sm"}`}
                      onClick={handleDelete}
                    >
                      <FaTrashAlt
                        style={{ fontSize: "14px" }}
                        className="mr-1 deleteColor"
                      />
                      Delete
                    </ButtonCommonDelete>
                  </div>
                </div>
              </div>
            </div>
          </div>

        )}
        {/* <div className='flex flex-col md:grid grid-cols-1 col-span-1 pt-2'>
                    <div className='flex flex-row flex-wrap md:flex-col w-full md:justify-evenly sm:justify-evenly justify-start  items-end px-5 md:px-0 md:space-y-5 col-span-2'>
                        <ButtonCommonTopNew
                            className={`${(isMobile2 || isMobile3) ? 'w-20 md:w-20' : 'w-24 md:w-24'} ${' rounded-lg py-2 mr-2 md:mr-0 flex mb-2 md:mb-0 justify-center items-center font-regular  text-xs lg:text-sm'}`}
                            onClick={handleEdit}
                        >
                            <BorderColorOutlinedIcon style={{ fontSize: '14px' }} className='mr-1 blueColor' />Edit
                        </ButtonCommonTopNew>
                        <ButtonCommonTopNew
                            className={`${(isMobile2 || isMobile3) ? 'w-20 md:w-20' : 'w-24 md:w-24'} ${'rounded-lg py-2 mb-2 md:mb-0 flex mr-2 md:mr-0 justify-center items-center font-regular  text-xs lg:text-sm'}`}
                            onClick={(e) => handleShareTo(e, item)}
                        >
                            <ShareIcon style={{ fontSize: '15px' }} className='mr-1 blueColor' />Share
                        </ButtonCommonTopNew>
                        <ButtonCommonDelete
                            className={`${(isMobile2 || isMobile3) ? 'w-20 md:w-20' : 'w-24 md:w-24'} ${'py-2 flex font-regular mb-2  text-xs lg:text-sm justify-center rounded-lg items-center '}`}
                            onClick={handleDelete}
                        >
                            <FaTrashAlt style={{ fontSize: '14px' }} className='mr-1 deleteColor' />Delete
                        </ButtonCommonDelete>
                    </div>
                </div> */}
      </div>
    </CardNew >
  );
};

export default JournalCards;
